import { useTranslation } from 'react-i18next';

/**
 * Why a deal was lost, chosen rather than typed.
 *
 * The dashboard's loss KPI groups by this exact value. While it was free
 * text it grouped by spelling, so "sem orçamento" and "Sem orçamento"
 * were two entries in one top five. Mirrors `VALID_LOST_REASONS` in
 * `backend/housien/models/deal/deal_model.py`; the backend answers 400
 * for anything outside it.
 *
 * `outro` is the escape hatch — a real cause is never forced into a
 * wrong one, and the broker's own words go in the note beside it.
 */
export const LOST_REASONS = [
  'sem_orcamento',
  'fechou_com_concorrente',
  'perfil_incompativel',
  'desistiu_da_busca',
  'imovel_indisponivel',
  'sem_resposta',
  'outro',
] as const;

export type LostReason = (typeof LOST_REASONS)[number];

/**
 * Hook returning localized labels for every loss reason.
 *
 * @returns A map from loss reason to its translated label.
 */
export function useLostReasonLabels(): Record<LostReason, string> {
  const { t } = useTranslation('features/deals');
  return Object.fromEntries(
    LOST_REASONS.map((reason) => [reason, t(`lostReasons.${reason}`)]),
  ) as Record<LostReason, string>;
}
